/* eslint-disable @typescript-eslint/naming-convention */
export enum ExportStatusEnum {
	Processing = 1,
	Error
}
